<script>

  export default {
    props: {
      title: {
        type: String,
        required: true,
      },
      message: {
        type: String,
        required: true,
      },
      okText: {
        type: String,
        default: 'Re-Login'
      },
    },
    data () {
      return {
      }
    },
    computed: {
      id(){
        return 'relog-modal'
      },
      messageSegments(){
        return this.message.split('\\n')
      }
    },
    methods: {
      confirm(){
        this.$customModal.hide(this.id)
        this.$emit('relogModalConfirmed')
      }
    },
  }
</script>

<template>
  <FabricModal
    :id="id"
    :heading="title"
    size="md"
    centered
    no-close-on-backdrop
    no-close-on-esc
    header-class="
      border-bottom-primary pd-x-0-f
      !tw-rounded-tl-inner !tw-rounded-tr-inner
      tw-bg-blend-color	tw-bg-gradient-to-r
      tw-from-red-400 tw-to-orange-500"
    footer-class="tw-flex tw-flex-col md:tw-flex-row !tw-justify-end"
  >
    <!-- Header -->
    <template v-slot:modal-header>
      <div class="custom-border-header-content mg-x-15 text-primary">
        <h5 class="h5 mg-b-u tx-weight-bold tw-pl-3 tw-text-black">{{title}}</h5>
      </div>
    </template>
    <!-- Footer -->
    <template v-slot:modal-footer>
      <button type="button" class="border-blue tw-border bg-col-white hover:tw-bg-blue-900 col-blue hover:tw-text-white tx-weight-bold border-rounded-20 mn-h-46 f-w-180 tx-tf-upper" @click="confirm">{{okText}}</button>
    </template>
    <!-- Body -->
    <template v-slot:modal-body>
      <section>
        <p v-if="messageSegments.length <= 1" class="tx-weight-bold tw-px-3">{{message}}</p>
        <section v-else>
          <p v-for="(segment, index) in messageSegments" :key="index" class="tx-weight-bold tw-px-3 mn-h-1r">{{segment}}</p>
        </section>
      </section>
    </template>
  </FabricModal>
</template>
